import React from 'react';
import Place from './subComponents/Place';
import Flight from './subComponents/Flight';

interface I_Props {
    isPlace: boolean;
}

const GroupTripInfo: React.FC<I_Props> = ({ isPlace }) => {
    return isPlace ? <Place /> : <Flight />;
};

export default GroupTripInfo;
